interface IconProps {
  className?: string;
}

const WebsiteCMSIcon: React.FC<IconProps> = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.9341 21.0305V10.0628C24.9341 8.92382 24.0155 8 22.8922 8H9.10781C7.98037 8 7.06589 8.92804 7.06589 10.0628V21.0305H5.5V23.0511C5.5 24.1268 6.36854 25 7.42917 25H24.5708C25.6356 25 26.5 24.1226 26.5 23.0511V21.0305H24.9341ZM8.10565 10.0628C8.10565 9.50596 8.55244 9.05459 9.10363 9.05459H22.888C23.4392 9.05459 23.886 9.50596 23.886 10.0628V21.0305H8.10147V10.0628H8.10565ZM25.4561 23.0511C25.4561 23.5447 25.0594 23.9454 24.5708 23.9454H7.42917C6.94062 23.9454 6.54393 23.5447 6.54393 23.0511V22.0851H14.0435V22.3382C14.0435 22.5913 14.2481 22.8022 14.5028 22.8022H17.5055C17.7561 22.8022 17.9649 22.5955 17.9649 22.3382V22.0851H25.4644V23.0511H25.4561Z"
      />
      <path
        d="M13.1697 14.4297C13.1616 14.5927 13.0307 14.723 12.8671 14.723H12C12.0818 13.444 12.7689 12.336 13.7832 11.668C13.4479 12.4338 13.227 13.3707 13.1697 14.4297Z"
        fill="#1A8B5A"
      />
      <path
        d="M14.6421 11.2444C14.9857 11.1141 15.3456 11.0326 15.7219 11.0163V14.4134C15.7219 14.5845 15.5828 14.723 15.411 14.723H14.045C13.865 14.723 13.7178 14.5682 13.7342 14.3971C13.816 13.1263 14.1513 11.9939 14.6421 11.2444Z"
        fill="#1A8B5A"
      />
      <path
        d="M17.3579 11.2444C17.8487 11.9939 18.184 13.1181 18.2658 14.3971C18.274 14.5764 18.135 14.723 17.955 14.723H16.589C16.4172 14.723 16.2781 14.5845 16.2781 14.4134V11.0163C16.6544 11.0326 17.0143 11.1141 17.3579 11.2444Z"
        fill="#1A8B5A"
      />
      <path
        d="M20 14.723H19.1329C18.9693 14.723 18.8384 14.5927 18.8303 14.4297C18.773 13.3788 18.5521 12.442 18.2168 11.668C19.2311 12.336 19.9182 13.444 20 14.723Z"
        fill="#1A8B5A"
      />
      <path
        d="M12.8671 15.277C13.0307 15.277 13.1616 15.4073 13.1697 15.5703C13.227 16.6212 13.4479 17.558 13.7832 18.332C12.7689 17.664 12.0818 16.556 12 15.277H12.8671Z"
        fill="#1A8B5A"
      />
      <path
        d="M15.411 15.277C15.5828 15.277 15.7219 15.4155 15.7219 15.5866V18.9837C15.3456 18.9674 14.9857 18.8859 14.6421 18.7556C14.1513 18.0061 13.816 16.8819 13.7342 15.6029C13.726 15.4236 13.865 15.277 14.045 15.277H15.411Z"
        fill="#1A8B5A"
      />
      <path
        d="M18.2658 15.6029C18.184 16.8737 17.8487 18.0061 17.3579 18.7556C17.0143 18.8859 16.6544 18.9674 16.2781 18.9837V15.5866C16.2781 15.4155 16.4172 15.277 16.589 15.277H17.955C18.135 15.277 18.2822 15.4318 18.2658 15.6029Z"
        fill="#1A8B5A"
      />
      <path
        d="M20 15.277C19.9182 16.556 19.2311 17.664 18.2168 18.332C18.5521 17.5662 18.773 16.6293 18.8303 15.5703C18.8384 15.4073 18.9693 15.277 19.1329 15.277H20Z"
        fill="#1A8B5A"
      />
      <path
        d="M15.7219 11H16C15.91 11 15.8119 11 15.7219 11.0163L15.7219 11Z"
        fill="#1A8B5A"
      />
      <path
        d="M16.2781 11V11.0163C16.1881 11 16.09 11 16 11H16.2781Z"
        fill="#1A8B5A"
      />
      <path
        d="M15.7219 18.9837C15.8119 19 15.91 19 16 19H15.7219V18.9837Z"
        fill="#1A8B5A"
      />
      <path
        d="M16.2781 18.9837V19H16C16.09 19 16.1881 19 16.2781 18.9837Z"
        fill="#1A8B5A"
      />
    </svg>
  );
};

export default WebsiteCMSIcon;
